import React from 'react';
import { Operation } from '../../hooks/useOperations/types';
import { importFromS3 } from '../../utils/importFromS3';

interface FusePluginContainerProps {
  operationsSelected: Operation[];
}

const FusePlugin = React.lazy(() => importFromS3('tcc-fuse'));

export const FusePluginContainer: React.FC<FusePluginContainerProps> = ({ operationsSelected }: FusePluginContainerProps) => (
  <FusePlugin operationsSelected={operationsSelected} />
);
